import axios from 'axios';
import { createApiObject } from './webhook.adapter';
import { RAYCHAT_GATEWAY_API_URL } from 'utils/constants';
import { kickUserOutIfTokenExpired } from 'utils';

const getAxiosInstance = (locale) => {
  const instance = axios.create({
    baseURL: RAYCHAT_GATEWAY_API_URL,
    withCredentials: false,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
      'Content-Type': 'application/json',
    },
  });

  kickUserOutIfTokenExpired(instance, locale);

  return instance;
};

export const handleFetchAllWebhooks = async (locale) => {
  const response = await getAxiosInstance(locale)({
    method: 'get',
    url: '/web-hook',
  });

  return response.data;
};

export const handleFetchWebhook = async (webhookId, locale) => {
  const response = await getAxiosInstance(locale)({
    method: 'get',
    url: `/web-hook/${webhookId}`,
  });

  return response.data;
};

export const handleAddNewWebhook = async (webhookObj, locale) => {
  const obj = createApiObject(webhookObj, 'add');

  const response = await getAxiosInstance(locale)({
    method: 'post',
    url: `/web-hook/set`,
    data: JSON.stringify(obj),
  });

  return response;
};

export const handleEditWebhook = async (webhook, locale) => {
  const editedWebhookObj = createApiObject(webhook, 'edit');

  const response = await getAxiosInstance(locale)({
    method: 'put',
    url: `/web-hook/${webhook.webhookId}`,
    data: editedWebhookObj,
  });

  return response.data;
};

export const handleToggleWebhookEnable = async (webhookId, locale) => {
  const response = await getAxiosInstance(locale)({
    method: 'patch',
    url: `/web-hook/${webhookId}/enable`,
  });

  return response.data;
};
